// src/services/task/TaskService.ts
import { BaseTenantCrudService } from '@/services/_base/BaseTenantCrudService'
import { type Task } from '@/types/Task.ts'
import type { IFirestoreService } from '@/platform/firebase/firestore'

type Session = { tenantId?: string; yardId?: string; userId?: string }

export class TaskService extends BaseTenantCrudService<Task> {
  constructor(firestore: IFirestoreService, session: Session) {
    super('tasks', firestore, session)
  }

  protected override beforeCreate(data: Partial<Task>): Partial<Task> {
    return {
      ...super.beforeCreate(data),
      status: data.status || 'todo',
      tags: data.tags || [],
    }
  }

  protected override async afterCreate(id: string, task: Partial<Task>) {
    console.log(`[TaskService] Created task ${id}`, task)
  }
}
